import { styled } from '@mui/system';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Typography,
  Pagination
} from '@mui/material';
import MuiDivider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';

export const ListHeaderCnt = styled('div')(({ theme }) => ({
  padding: '11px 0 11px 16px',
  '& .listTitle': {
    margin: 0
  },
  borderTopLeftRadius: theme.spacing(),
  borderTopRightRadius: theme.spacing()
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  marginBottom: theme.spacing(2),
  textTransform: 'uppercase'
}));

export const CloseListCnt = styled('div')({
  position: 'relative'
});

export const CloseListBtn = styled(IconButton)({
  position: 'absolute',
  padding: 0,
  top: 0,
  right: 12,
  cursor: 'pointer',
  marginTop: 2
});

export const ListCnt = styled('div')({
  overflow: 'hidden auto',
  height: 'calc(100% - 52px)',
  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar': {
    width: 8,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 10,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: '#a0a0a0'
  }
});

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '&.Mui-expanded': {
    margin: 0,
    '&:before': {
      opacity: 1
    },
    '& + .MuiAccordion-root': {
      '&:before': {
        display: 'block'
      }
    }
  },
  '& li': {
    paddingLeft: 0,
    paddingRight: theme.spacing()
  },
  boxShadow: 'none'
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: '0px 8px 0 16px',
  maxHeight: '64px',
  [theme.breakpoints.down('md')]: {
    padding: '0 8px 0 16px'
  },
  '& li': {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  '& .MuiAccordionSummary-content': {
    margin: 0
  },
  '& .MuiAccordionSummary-expandIcon': {
    maxWidth: 29,
    padding: '12px 0px',
    right: 12
  }
}));

export const StyledAccordionDetails = styled(AccordionDetails)({
  flexWrap: 'wrap',
  padding: '0px 0px 16px'
});

export const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: '32px !important'
});

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& span': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    [theme.breakpoints.up('XGA')]: {
      maxWidth: '90%'
    }
  },
  '&.alertColor': {
    color: '#f44336'
  }
}));

export const LinkShowAll = styled(Link)({
  display: 'block',
  minWidth: '150px',
  cursor: 'pointer',
  padding: '16px 0px',
  textAlign: 'center',
  textDecoration: 'none',
  '& span': {
    color: '#212121',
    borderBottom: '1px #212121 solid',
    paddingTop: 3,
    '&:hover': {
      borderColor: 'transparent'
    }
  }
});

export const CardsAlignment = styled('div')(({ theme }) => ({
  backgroundColor: '#EEE',
  minHeight: '100%',
  textAlign: 'center',
  padding: theme.spacing(1, 1, 0, 1),
  margin: theme.spacing(0, 0, 0, 0),
  position: 'fixed',
  top: '50px',
  left: 0,
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  paddingBottom: '50px',
  zIndex: 2
}));

export const MobileTitle = styled('h4')(({ theme }) => ({
  fontWeight: 500,
  marginBottom: theme.spacing(2)
}));

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(2)
  },
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const Divider = styled(MuiDivider)({
  marginTop: '-1px !important'
});
